import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SectionHeader from "../SectionHeader";
import "./style.scss";
import Button from "../Button";
import { useNavigate } from "react-router";
import prizeBg from "@assets/decor.png";
import DOMPurify from "dompurify";

const MyNiceModal = NiceModal.create(() => {
  const navigate = useNavigate();
  const modal = useModal();

  const handleClose = () => {
    modal.hide();
    navigate("/activities/birthdayglo_2025/gra?status=success");
  };

  const prize = modal?.args?.prize;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        handleClose();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"win-wheel-modal"}
    >
      <SectionHeader>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(prize?.title)}}></p>
      </SectionHeader>

      {prize.points ? (
        <div className="reward-box">
          <div className="value">
            <img className="img" src={prizeBg} alt={prize.points} />
            <div className="prize">
              <div className="inner">
                +{prize.points}
                <span className="prize-copy">Punkte</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="answer-copy">
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(prize?.content)}}></p>
          <img alt="prize img" src={prize?.img} />
        </div>
      )}

      <div className="buttons-wrapper">
        <Button
          action={() => {
            handleClose();
          }}
          btnClass="yellow"
        >
          Gleich sichern
        </Button>
      </div>
    </Modal>
  );
});

export default MyNiceModal;
